// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__IqY1c","actionsCol":"EnrolledClinics_actionsCol__3LOXB"};